import { createAsyncThunk } from '@reduxjs/toolkit';

import { ehErroHttp } from '@/shared/utils/erroHttp';
import type { RootState } from '@/store';

import type {
  DocumentoAssinadoArDto,
  EnvioFisicoArDocumentoAssinavel,
  ListaEnviosFisicosArDto,
} from '../../types/envioFisicoArTypes';
import { envioFisicoArService } from './services';

export interface FalhaEnvioFisicoAr {
  mensagem: string;
  status: number | null;
}

function comoFalha(error: unknown, mensagemPadrao: string): FalhaEnvioFisicoAr {
  if (ehErroHttp(error)) return { mensagem: error.message, status: error.status };
  return { mensagem: mensagemPadrao, status: null };
}

interface AlvoDoEnvio {
  processoArbitralId: string;
  envioFisicoId: string;
}

export const fetchEnviosFisicosAr = createAsyncThunk<
  ListaEnviosFisicosArDto,
  { processoArbitralId: string; page: number },
  { rejectValue: FalhaEnvioFisicoAr; state: RootState }
>('envioFisicoAr/fetch', async ({ processoArbitralId, page }, { rejectWithValue }) => {
  try {
    return await envioFisicoArService.listar(processoArbitralId, page);
  } catch (error) {
    return rejectWithValue(comoFalha(error, 'Não foi possível carregar o envio físico'));
  }
});

/**
 * O link é devolvido a quem clicou e NÃO vai para o estado: expira em minutos, e guardá-lo
 * convidaria a reusar um link morto num segundo clique.
 */
export const abrirDocumentoEnvioFisicoAr = createAsyncThunk<
  DocumentoAssinadoArDto,
  AlvoDoEnvio & { tipo: EnvioFisicoArDocumentoAssinavel },
  { rejectValue: FalhaEnvioFisicoAr; state: RootState }
>(
  'envioFisicoAr/abrirDocumento',
  async ({ processoArbitralId, envioFisicoId, tipo }, { rejectWithValue }) => {
    try {
      return await envioFisicoArService.documento(processoArbitralId, envioFisicoId, tipo);
    } catch (error) {
      return rejectWithValue(comoFalha(error, 'Não foi possível abrir o documento'));
    }
  },
);
